var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/file_minus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-48, -839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/File-Minus",
    transform: "translate(48, 839)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,6.23789063 L20.5,6.5 L14.8333333,6.5 L14.8333333,1 L15.1033854,1 C15.3867187,1 15.6567708,1.10742188 15.8559896,1.30078125 L20.1901042,5.51171875 C20.3893229,5.70507812 20.5,5.9671875 20.5,6.23789063 Z M14.4791667,7.875 L20.5,7.875 L20.5,21.96875 C20.5,22.5402344 20.0263021,23 19.4375,23 L4.5625,23 C3.97369792,23 3.5,22.5402344 3.5,21.96875 L3.5,2.03125 C3.5,1.45976562 3.97369792,1 4.5625,1 L13.4166667,1 L13.4166667,6.84375 C13.4166667,7.4109375 13.8947917,7.875 14.4791667,7.875 Z M16.0729167,16.125 C16.3651042,16.125 16.6041667,15.8929688 16.6041667,15.609375 L16.6041667,13.890625 C16.6041667,13.6070312 16.3651042,13.375 16.0729167,13.375 L7.92708333,13.375 C7.63489583,13.375 7.39583333,13.6070312 7.39583333,13.890625 L7.39583333,15.609375 C7.39583333,15.8929688 7.63489583,16.125 7.92708333,16.125 L16.0729167,16.125 Z",
    id: "Icon",
    fill: "#B1B6C3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMinus);
export default __webpack_public_path__ + "static/media/file_minus.07516d6a.svg";
export { ForwardRef as ReactComponent };